import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-pricing-promise-section',
  imports: [TuiIcon, SectionHeaderComponent],
  templateUrl: './pricing-promise-section.component.html',
  styleUrl: './pricing-promise-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingPromiseSectionComponent {}
